// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateSocialItemModal-cls1___39b33dfc51d28372dcc{/*!*/}.CreateSocialItemModal-cls2__f90e66606f38c3ba71bd{border-radius:8px !important;border-radius:var(--corner-radius-radius-md, 8px) !important;padding:18px 8px;background:rgba(20,20,19,.7)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CreateSocialItemModal-cls1___39b33dfc51d28372dcc",
	"cls2": "CreateSocialItemModal-cls2__f90e66606f38c3ba71bd CreateSocialItemModal-cls1___39b33dfc51d28372dcc"
};
export default ___CSS_LOADER_EXPORT___;
